/**
 *  Portfolio Project Categories
 */
export default ["Enterprise", "Startups", "MVP", "MS", "Angular", "React", "Azure", "AWS", "Analytics"]